import { apiWrapper } from "@/services/api";

export const getQrString = async (id) => {
  try {
    const resp = await apiWrapper("GET", `passes/${id}/verification_string`);
    return resp.data;
  } catch (err) {
    console.log("ERROR!!! getQrString");
    throw err;
  }
};
